import React from 'react';
import moment from 'moment';
import LazyLoad from '../../common/components/LazyLoad';
import { Icon } from '../../common/components/Utilities';
import PullsResource from '../../common/resource/PullsResource';

// const RelativeTime = ({ mins }) => {
//   const formatter = Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 });
//
//   if (mins >= 924) {
//     return `${formatter.format(mins / 462)} days`;
//   }
//
//   if (mins >= 120) {
//     return `${formatter.format(mins / 60)} hours`;
//   }
//
//   return `${mins} minutes`;
// };

export default function ({ assigned = false, user }) {
  return (
    <LazyLoad
      resourceAction={PullsResource.index}
      params={[{
        assigned_id: assigned ? user : null,
        user_id: assigned ? null : user,
        is_open: 1,
        not_draft: 1,
        stats: 1,
      }]}
      defaultData={0}
      render={(loading, { total, oldest }) => {
        if (loading) {
          return <Icon icon="circle-notch" variant="fad" append="fa-spin text-info" fixed />;
        }

        return (
          <>
            <div className={total > 5 ? 'text-danger' : ''}>
              <strong>{total}</strong>
              {' '}
              {assigned ? 'assigned' : 'open'}
              {' '}
              PRs
            </div>
            {total !== 0 && (
            <div className={`small ${moment().diff(moment(oldest), 'day') > 5 ? 'text-danger' : 'text-muted'}`}>
              Oldest:
              {' '}
              {moment(oldest).fromNow(true)}
            </div>
            )}
          </>
        );
      }}
    />
  );
}
